import styled from 'styled-components';
import { IMonnitoringLayoutStyledProps } from './monitoring.types';

export const MonnitoringLayoutStyled = styled.div<IMonnitoringLayoutStyledProps>`
  display: grid;
  grid-template-rows: ${({ $isCollapsed }) => $isCollapsed ? '1fr' : 'auto 1fr'};
  height: 100vh;
  min-width: 160px;
`;
